@if (!editing) {
  <div
    class="editable"
    (click)="edit()"
    (focus)="edit()"
    tabindex="0"
    [ngClass]="{ readonly: readonly }"
    [matTooltip]="showTip"
    [class.locked]="fieldDef.locked"
  >
    @if (!isNestedField) {
      {{ fieldMask ? (value | mask: fieldMask(value)) : value }}
    } @else {
      <linkable-related-field-cell [type]="fieldDef?.related_to_type" [value]="value"></linkable-related-field-cell>
    }
  </div>
} @else {
  <input
    #inputEditorControl
    type="text"
    tabindex="0"
    [maxLength]="1024"
    [disabled]="isDisabled"
    [(ngModel)]="value"
    (blur)="onBlur()"
    (keyup.enter)="onBlur()"
  />
}
